import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Generate or get session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('vyta_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
    sessionStorage.setItem('vyta_session_id', sessionId);
  }
  return sessionId;
};

export default function AnalyticsTracker() {
  const location = useLocation();
  const sessionStart = useRef(Date.now());
  const lastPage = useRef(null);

  useEffect(() => {
    const sessionId = getSessionId();
    
    // Log page visit
    const logVisit = async () => {
      try {
        await fetch(`${API_URL}/analytics/visit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            session_id: sessionId,
            page: location.pathname,
            user_agent: navigator.userAgent,
            referrer: document.referrer || null,
          }),
        });
      } catch (err) {
        // Silently fail - analytics shouldn't break the app
      }
    };

    logVisit();
    lastPage.current = location.pathname;
  }, [location.pathname]);

  // Track session duration on page unload
  useEffect(() => {
    const handleUnload = () => {
      const sessionId = getSessionId();
      const duration = Math.round((Date.now() - sessionStart.current) / 1000);
      
      // Use sendBeacon for reliable delivery on page close
      navigator.sendBeacon(
        `${API_URL}/analytics/session-end?session_id=${sessionId}&total_duration=${duration}`
      );
    };

    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, []);

  // Error tracking disabled to avoid capturing browser-internal errors
  // that create noise (postMessage, ResizeObserver, etc.)

  return null; // This component doesn't render anything
}
